import { render } from "./MessageTempate.vue?vue&type=template&id=c8a783e4&scoped=true&lang=pug"
import script from "./MessageTempate.vue?vue&type=script&lang=js"
export * from "./MessageTempate.vue?vue&type=script&lang=js"

import "./MessageTempate.vue?vue&type=style&index=0&id=c8a783e4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a783e4"]])

export default __exports__